/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

'use client';

import Link from 'next/link';
import { useState } from 'react';

import { useAuthService } from '@/hooks/useAuthService';
import { useTranslation } from '@/lib/i18n';
import { logger } from '@/lib/logger';

/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Forgot Password Page
 * Modern forgot password page with Tailwind CSS styling
 */

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { t } = useTranslation();
  const authService = useAuthService();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // call the customer forgot-password API
      try {
        const { success: ok } = await authService.forgotPasswordCustomer(email);
        if (ok || ok === undefined) {
          logger.info({ msg: 'Password reset requested', email });
          setSuccess(true);
        } else {
          throw new Error('unexpected response');
        }
      } catch (err) {
        throw err;
      }
    } catch (err) {
      setError(t('auth.forgotPassword.errorSendingEmail'));
      logger.error({ msg: 'Password reset error', error: err });
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">{t('auth.forgotPassword.emailSent')}</h2>
              <p className="mt-2 text-center text-sm text-gray-600">{t('auth.forgotPassword.emailSentMessage').replace('{email}', email)}</p>
              <div className="mt-6 space-y-3">
                <Link
                  href="/login"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  {t('auth.forgotPassword.backToLogin')}
                </Link>
                <Link
                  href="/reset-password"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-blue-600 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  {t('auth.forgotPassword.resetNow')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">{t('auth.forgotPassword.title')}</h2>
        <p className="mt-2 text-center text-sm text-gray-600">{t('auth.forgotPassword.description')}</p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            {error && <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded">{error}</div>}

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                {t('auth.email')}
              </label>
              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  placeholder={t('auth.emailPlaceholder')}
                  data-testid="forgot-password-email"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={isLoading}
                data-testid="forgot-password-submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? t('auth.forgotPassword.sending') : t('auth.forgotPassword.sendResetLink')}
              </button>
            </div>

            <div className="text-center">
              <Link href="/login" className="font-medium text-blue-600 hover:text-blue-500">
                {t('auth.forgotPassword.backToLogin')}
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
